import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Mimic } from 'icreate/common/models/mimic';
import { ProjectStatus, Vessel } from 'icreate/common/models/vessel';
import { zoomDependentAttributes } from '@models/editor';
import { AuthService } from '@service/auth.service';
import { CanvasService } from '@service/canvas/canvas.service';
import { EditorService } from '@service/editor.service';
import { MimicsService } from '@service/mimics.service';
import { PopUpNotificationComponent } from '@components/pop-up-notification/pop-up-notification.component';

@Injectable({
    providedIn: 'root',
})
export class EditorMimicActionsService {
    constructor(
        private dialog: MatDialog,
        private authService: AuthService,
        private canvasService: CanvasService,
        private editorService: EditorService,
        private mimicService: MimicsService
    ) {}

    canCreateOrDelete(vessel: Vessel | undefined, userCanEdit: boolean): boolean {
        if (!vessel) return false;
        if (vessel.projectStatus == ProjectStatus.undefined) return false;
        if (vessel.projectStatus == ProjectStatus.Editing) {
            const currentUser = this.authService.getCurrentUser();
            if (currentUser.oid == vessel.ownerOid) {
                return true;
            }
            return userCanEdit;
        }
        return false;
    }

    showNoPermissionDialog(): void {
        this.dialog.open(PopUpNotificationComponent, {
            width: '474px',
            data: {
                title: 'general.api.permission-denied.title',
                message: 'general.api.permission-denied.message',
                message2: 'general.api.permission-denied.message-2',
            },
        });
    }

    serializeCurrentSvg(): string {
        const currentSvgContent = this.canvasService.getSvgContent();
        const inputs = currentSvgContent.getElementsByTagName('input');
        for (let i = 0; i < inputs.length; i++) {
            let inputElement = inputs[i];
            let htmlString = inputElement.outerHTML;
            htmlString = htmlString.replace(/<input(.*?)>/, '<input$1 />');
            inputElement.outerHTML = htmlString;
        }
        return new XMLSerializer().serializeToString(currentSvgContent);
    }

    mimicHasChanged(initialSvgContent: string): boolean {
        return !_.isEqual(
            this.stripZoomAttributes(initialSvgContent),
            this.stripZoomAttributes(this.serializeCurrentSvg())
        );
    }

    private stripZoomAttributes(svgContent: string): string {
        if (!svgContent) return svgContent;

        const parsed = new DOMParser().parseFromString(svgContent, 'image/svg+xml');
        if (parsed.querySelector('parsererror')) return svgContent;

        const root = parsed.documentElement;
        zoomDependentAttributes.forEach(attribute => root.removeAttribute(attribute));
        return new XMLSerializer().serializeToString(root);
    }

    async duplicateMimic(mimic: Mimic, getNextId: () => string): Promise<void> {
        const idMapping: Record<string, string> = {};
        mimic.svgcontent.replace(/id="(svg_[^"]+)"/g, (_match, oldId) => {
            idMapping[oldId] = getNextId();
            return oldId;
        });
        await this.mimicService.duplicate(mimic, idMapping);
    }
}
